// Label used for the "unfiled" choice in the move-to submenu. Sessions
// without a `customFolderId` render at the root of the Recents list,
// outside any folder wrapper.
export const DEFAULT_FOLDER_LABEL = 'Sessions';

// Sentinel id for the unfiled option in the context-menu "Move to" list.
// Selecting it clears the session's `customFolderId`.
export const DEFAULT_FOLDER_ID = '__default__';

// Custom dataTransfer MIME used by SessionRow drag → folder drop. Lower-case
// per the dnd spec; checking `dataTransfer.types.includes(...)` on dragover
// lets drop zones reject foreign drags (text, files) without inspecting data.
export const SESSION_DRAG_TYPE = 'application/x-terminal-session-id';
